type GraphQLError = {
  message: string;
};

type GraphQLResponse<TData> = {
  data?: TData;
  errors?: GraphQLError[];
};

const getGraphQLEndpoint = () => {
  const apiEndpoint = process.env.NEXT_PUBLIC_API_ENDPOINT;

  if (!apiEndpoint) {
    throw new Error("Missing NEXT_PUBLIC_API_ENDPOINT");
  }

  return `${apiEndpoint.replace(/\/+$/, "")}/graphql`;
};

export const postGraphQL = async <
  TData,
  TVariables extends Record<string, unknown>
>(
  query: string,
  variables: TVariables
) => {
  const response = await fetch(getGraphQLEndpoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query, variables }),
  });

  const payload = (await response.json()) as GraphQLResponse<TData>;

  if (!response.ok || payload.errors?.length || !payload.data) {
    throw new Error(
      payload.errors?.[0]?.message ??
        `GraphQL request failed with status ${response.status}`
    );
  }

  return payload.data;
};
